import styled from 'styled-components';
import media from "styled-query";

export const Container = styled.section`
  display: flex;
  max-height: 100vh;
  height: 100vh;
  width: 100%;

  /* background: #0080003b; */
`;

export const Text = styled.span`
  /* font-size: 3rem; */
  font-size: 5vmin;
  font-weight: bold;
  color: var(--white);
  z-index: 2;

  ${media.lessThan("1023px")`
    font-size: 2rem;
  `}
`;

export const Content = styled.div`
  display: flex;
  flex: 3;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  background: var(--black);
  color: white;
  font-weight: bold;

  h1 {
    display: none;
  }

  .spotlight {
    /* font-size: 3rem; */
    font-size: 5vmin;
    font-weight: bold;
    color: var(--primary);
    ${media.lessThan("1023px")`
      font-size: 2rem;
    `}
  }

  ${media.lessThan("1023px")`
    padding: 0 24px;
  `}

  /* background: #ff000036; */
`;

export const Image = styled.div`
  display: flex;
  flex: 2;
  position:relative;

  ${media.lessThan("1023px")`
    display: none;
  `}

  /* background: #a6ecec5e; */
`;

export const GradientW = styled.div`
  position: absolute;
  z-index: 999;
  width: 100px;
  height: 100%;
  /* background: red; */
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, transparent 100%);
`;

export const GradientH = styled.div`
  position: absolute;
  z-index: 999;
  width: 100%;
  height: 125px;
  top: 0;
  /* background: red; */
  background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 65%, transparent 100%);
`;

export const Input = styled.div`
  border: 2px solid var(--black);
  /* width: 70%; */
  max-width: 450px;
  height: 70px;
  border-radius: 35px;
  margin: 2rem 0 1rem 0;
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 25px;
  background: var(--white);
  z-index: 2;

  span {
    font-weight: bold;
    color: var(--black);
  }

  input {
    width: 100%;
    flex: 1;
    border: 0;
    margin-left: 2px;
    color: #5f5f5f;
    font-size: 1rem;
    font-weight: bold;

    &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #5f5f5f;
    }

    ${media.lessThan("1023px")`
      width: 100%;
    `}

    /* background: blue; */
  }

  /* background: red; */
`;

export const Button = styled.div`
  height: 60px;
  width: 100px;
  border: none;
  background: var(--black);
  color: var(--white);
  font-weight: bold;
  border-radius: 30px;
  margin-right: 5px;
  justify-content: center;
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;

export const Info = styled.div`
  display: flex;
  max-width: 600px;
  justify-content: center;
  z-index: 2;

  span {
    width: 70%;
  }

  ${media.lessThan("530px")`
    span {
      width: 100%;
      font-size: 1.5rem;
    }
  `}

  ${media.lessThan("425px")`
    span {
      width: 100%;
      font-size: 1.4rem;
    }
  `}

`;

export const StaticImageNormal = styled.div`
  display: block;
  display: flex;
  align-items: flex-end;
  ${media.lessThan("530px")`
      /* display: none; */
  `}
`;

export const Alert = styled.span`
  display: ${({isVisible}) => isVisible ? 'block' : 'none'};
  height: 60px;
  width: 50%;
  color: red;
  font-weight: bold;
  z-index: 2;
`;

export const Movie = styled.div`
  position: absolute;
  /* width: 100vw;
  height: 100vh; */
  z-index: 1;
  opacity: 0.5;

  width: 100%;
  height: 100vh;
  overflow:hidden;
  /* display:block; */

  ${media.lessThan("1023px")`
    /* width: 100%;
    height: auto; */
    width: 100vw;
  `}

  video {
    /* height: 100vh; */

    /* height: 100vh;
    max-width: 100vw; */
    /* margin-left: -220px; */

    position: relative;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: 65% 20%;
    object-position: 65% 20%;
    font-family: "object-fit: cover";
    width: 100%;
    height: 100%;
    pointer-events: none;

    /* ${media.lessThan("1023px")`
      width: auto;
      height: 100vh;
    `} */
  }


`;
